import Country from "./CountryService";
import { CountryData } from "types";

class IsoCodeService {
  constructor(private country: Country = Country.getInstance()) {}

  public get(countryName: string): string {
    return this.country.getIsoCode(countryName);
  }

  public getByIsoCode(isoCode: string): CountryData | undefined {
    return this.country.getByIsoCode(isoCode);
  }
}

export default IsoCodeService;
